const en = {
    create_course: 'Create course',
    course_list: 'Course list',
    course_trainer: 'Trainers',
    courses_public: 'Published',
    courses_reserved: 'Reserved',
    courses_finished: 'Finished',
    courses_deleted: 'Deleted',
    courses_workinprogress: 'Draft',
    public: 'public',
    published: 'public',
    reserved: 'reserved',
    ended: 'ended',
    deleted: 'deleted',
    workinprogress: 'draft',
    courses: 'Courses',
    welcome: 'welcome',
    in_education_area: 'to the education area',
    duplicate_course: 'Duplicate course',
    configure_new_course: 'Configure a new course',
    configure_start_course: 'Start configuring the course',
    ask_help_courses: 'Ask for help',
    course_help_title: 'Do you need help with your course?',
    course_help_text:
        'Get practical assistance and free personalized advice from one of our expert trainers',
    course_information: 'Course information',
    course_title: 'Title',
    course_subjectarea: 'Course subject area',
    course_place: 'Course delivery mode',
    course_online: 'online',
    course_presence: 'in-person',
    course_hybrid: 'hybrid',
    course_availability: 'Course access permissions',
    course_availability_table: 'Access permissions',
    course_public: 'public',
    course_private: 'private',
    course_type: 'Access type',
    course_sync: 'synchronous',
    course_async: 'asynchronous',
    course_address: 'Location information',
    course_step_1: 'Configure course',
    course_info: 'Course information',
    course_description: 'Course description',
    course_other_info: 'Additional information',
    course_number_lessons: 'Number of lessons',
    course_hours: 'Number of hours',
    course_min_partecipants: 'Min participants',
    course_max_partecipants: 'Max participants',
    course_select_trainer: 'Select trainer',
    course_material: 'Course materials',
    course_visibility: 'Do you want to make participants visible?',
    course_consult: 'Consult the course!',
    course_consult_info: 'You can add more information or make changes at any time.',
    course_summary: 'Course summary',
    search_course: 'Search course',
    course_area: 'Subject area',
    course_lessons: 'Lessons',
    course_hour: 'Hours',
    course_dispensing: 'Delivery',
    course_registration: 'Request registration',
    course_name: 'Course name',
    course_partecipants: 'Participants',
    course_starting_date: 'Start date',
    course_desc: 'Description',
    course_teachers: 'Teachers',
    course_partecipate: 'Participate',
    course_modality: 'Delivery mode',
    course_subscription: 'Your registrations',
    course_next_lessons: 'Upcoming lessons',
    course_permissions: 'Access permissions',
    course_next_lesson: 'Next lesson',
    course_update: 'Edit course',
    course_update_teachers: 'Edit trainers',
    course_add_materials: 'Add materials',
    course_end: 'End course',
    course_delete: 'Delete course',
    course_restore: 'Restore course',
    course_duplicate: 'Duplicate course',
    course_infos: 'Information',
    course_add_partecipants: 'Add participants',
    course_workinprogress: 'Draft',
    course_no_lessons: 'No lessons available',
    course_empty_list: 'No course available',
    enrollment: {
        ongoing: 'Ongoing',
        coming_soon: 'Upcoming',
        finished: 'Finished',
    },
    course_detail: {
        modality: 'Course delivery mode',
        venue: 'Venue',
        permissions: 'Permissions',
        mode: 'Mode',
        course_mode: 'Course mode',
        download_course_report: 'Download course report',
        course_create_lesson: 'Create your lessons',
        add_lesson: 'Add lesson',
        edit_lesson: 'Edit lesson',
        delete_lesson: 'Delete lesson',
        new_lesson: 'New lesson',
        lesson_title: 'Lesson title',
        lesson_link: 'Lesson link',
        select_docent: 'Select trainer',
        hour_start: 'Start time',
        hour_end: 'End time',
        search_user: 'Search user',
        lesson_start: 'Start lesson',
        user: 'User',
        registration: 'Registration',
        action: 'Action',
        add_partecipant: 'Add participants',
        delete_partecipant: 'Remove participants',
        invite_trainers: 'Invite trainers',
        invite_trainer: 'Invite trainer',
        company: 'Company',
        send_email: 'Send email',
        remove: 'Remove',
        deactivate: 'Deactivate',
        approve: 'Approve',
        add_selected_partecipant: 'Add the following students to the course?',
        delete_selected_partecipant: 'Remove the following students from the course?',
    },
    subject: 'Subject',
    lessons: 'lessons',
    hours: 'hours',
    partecipants: 'min {min} / max {max} participants',
    from_to: 'from {min} to {max}',
    course_status: {
        draft: 'Draft',
        private: 'Private',
        published: 'Public',
    },
    course_timing: {
        sync: 'Synchronous',
        async: 'Asynchronous',
    },
    course_location: {
        presence: 'In-person',
        online: 'Online',
        hybrid: 'Hybrid',
    },
    job_cover_image_info:
        'This image will be visible in the course detail (the required format is horizontal)',
    invalid_email: 'Invalid email',
    required_email: 'Email field is required',
    required_name: 'Name field is required',
    collaborator: 'Collaborator',
    change_role_tooltip:
        'To remove the trainer, go to the company management section of the whp platform',
    request_course_signup: 'Course registration',
    request_course_signup_info:
        'To submit your registration request, press Send and wait for confirmation',
    areas: {
        sales_and_marketing: 'Sales & Marketing',
        legal: 'Legal',
        social: 'Social',
        advertising: 'Advertising',
        communication: 'Communication',
        design: 'Design',
        content_creation: 'Content creation',
        audiovision: 'Audiovision',
        data_analytics: 'Data analytics',
        finance: 'Finance',
        web_and_mobile_developing: 'Web & Mobile development',
        information_technology: 'Information technology',
        management: 'Management',
        human_resources: 'Human resources',
    },
    subject_area: 'subject area',
    new_lesson_added: 'New lesson added',
    lesson_edited: 'Lesson edited',
    lesson_deleted: 'Lesson deleted',
    student_status: {
        denied: 'Denied',
        waiting: 'Waiting',
        revoked: 'Revoked',
        abandoned: 'Abandoned',
        completed: 'Completed',
        subscribed: 'Enrolled',
    },
    published_courses: 'published courses',
    course_list_filters: {
        online: 'Online',
        presence: 'In Presence',
        hybrid: 'Hybrid',
        from_to: 'from {start} to {end}',
        over: 'over {number}',
        until: 'until {number}',
        public: 'Public',
        private: 'Private',
        synchronous: 'Synchronous',
        asynchronous: 'Asynchronous',
        mixed: 'Mixed',
    },
};

export default en;
